import React from 'react'
import GistList from './GistList'
import GistDetail from './GistDetail'

export default function SplitView() {
  return (
    <div className="flex h-screen">
      <div className="w-[30%] overflow-y-auto border-r border-base-300 relative">
        <GistList />
      </div>

      <div className="flex-1 overflow-y-auto">
        <GistDetail />
      </div>
    </div>
  )
}
